import { StringUtils } from "Global/Base/Utils/StringUtils";
import { InvalidOperationException } from "../../../Global/Base/Exceptions";
import { Localization } from "../../../OW.Remoting/Remoting/Localization";

/**
 * Pomocné metody pro práci z HTML elementy
 * @includeToDoc
 */
export class ElementUtils {
    /**
     * Zjistí jestli je na daném elementu zobrazen scrollbar
     * @param element element, na kterém se zjišťuje zobrazeni scrollbaru
     * @return true pokud je scrollbar zobrazen
     */
    public static hasScrollBar(element: HTMLElement): boolean {
        // tohle je workaround pro safari, kde tam pri zoomu stranky dochazelo k tomu, ze i bez scrollbaru byla tato hodnota vyssi
        const offset = document.body.scrollHeight - window.innerHeight;

        return element.offsetHeight < (element.scrollHeight - offset);
    }

    /**
     * Přidá nebo odstraní bezhodnotový atribut
     * @param element element, na kterém se má atribut zobrazit/skrýt
     * @param attributeName název atributu
     * @param showAttribute zda se má zobrazit nebo skrýt
     */
    public static toggleAttribute(element: HTMLElement, attributeName: string, showAttribute: boolean): void {
        showAttribute ? element.setAttribute(attributeName, "") : element.removeAttribute(attributeName);
    }

    /**
     * Aktualizuje text v elementu
     * @param element Element k aktualizaci
     * @param text Text ke zobrazení
     * @param defaultLocKey Lokalizační klíč použitý v případě, že není nastaven žádný text
     */
    public static updateElementTextContent(element: HTMLElement, text: string, defaultLocKey: string): void {
        if (text) {
            Localization.remLocData(element);

            element.textContent = text;
            element.title = text;
        } else {
            Localization.addLocData(element, defaultLocKey);
        }
    }

    /**
     * Vrátí pozici elementu v rámci dokumentu
     * @param elem Element, kterého se to týká
     */
    public static offset(elem: HTMLElement): { top: number; left: number } {
        const doc = elem && elem.ownerDocument;
        if (!doc)
            throw new InvalidOperationException("Unavailable 'ownerDocument' property");

        const docElem = doc.documentElement;
        const box = elem.getBoundingClientRect();
        const win = doc.defaultView;
        return {
            top: box.top + win.pageYOffset - docElem.clientTop,
            left: box.left + win.pageXOffset - docElem.clientLeft,
        };
    }

    /**
     * Funkce vraci true, pokud je dana pozice v elementu
     * @param element Element
     * @param event Událost nebo souradnice
     * @returns true pokud je v elementu
     */
    public static inElement(element: HTMLElement, event: MouseEvent | CustomEvent | { x: number; y: number }): boolean {
        let inEl = false;
        const pageX = event instanceof MouseEvent ? event.pageX : event instanceof CustomEvent ? event.detail ? event.detail.x : 0 : event.x;
        const pageY = event instanceof MouseEvent ? event.pageY : event instanceof CustomEvent ? event.detail ? event.detail.y : 0 : event.y;

        //let pos = $(element).offset();
        const pos = ElementUtils.offset(element);

        if ((pageX > pos.left && pageX < (element.offsetWidth + pos.left)) && (pageY > pos.top && pageY < (element.offsetHeight + pos.top))) {
            inEl = true;
        }
        return inEl;
    }

    /**
     * Vyvolá zadanou událost na předaném elementu
     * @param element Element, na kterém má událost vzniknout
     * @param eventName Název události, která se má vyvolat
     * @param detail Podrobnosti události
     * @param bubbles Zda má událost probublávat DOMem (dafaultně ne)
     * @param cancelable Zda má jít událost zrušit (defaultně ne)
     * @return Vrátí vytvořený CustomEvent
     */
    public static callEvent<TData>(element: HTMLElement, eventName: string, detail?: TData, bubbles: boolean = false, cancelable: boolean = false): CustomEvent {
        const param = {
            detail: detail,
            bubbles: bubbles,
            cancelable: cancelable,
        };
        const evt = new CustomEvent(eventName, param);
        element.dispatchEvent(evt);
        return evt;
    }

    public static highlightText(text: string, element: HTMLElement): void {
        //const query = new RegExp("(\\b" + text + "\\b)", "gim");
        //const query = new RegExp("(" + text + ")", "gim");
        let reg = "";
        for (const t of text) {
            reg += StringUtils.getToRegEx(t);
        }
        const query = new RegExp(`(${reg})`, "gim"); //`
        const e = element.innerHTML;
        const enew = e.replace(/(<span>|<\/span>)/igm, "");
        element.innerHTML = enew;
        const newe = enew.replace(query, "<span>$1</span>");
        element.innerHTML = newe;
    }

    public static clearHighlight(element: HTMLElement): void {
        if (!element)
            return;
        const innerText = element.innerHTML;
        element.innerHTML = innerText.replace(/(<span>|<\/span>)/igm, "");
    }
}
